import type { FaireThemeEntity } from "../../entity_types/theme";

export const rustic_depot_small_batch_caramels_chocolate_giftables: FaireThemeEntity =
  {
    token: "rustic-depot-small-batch-caramels-chocolate-giftables",
    type: "theme",
    retailerToken: "r_464eox2tas",
    name: "Small-Batch Caramels & Chocolate Giftables",
    description: "Artisan confections perfect for gift baskets",
    bgColor: "#D4E8D4",
    tileBgColor: "#7e7433",
    productTokens: [
      "p_5aeuy9zgag",
      "p_chg7se2my5",
      "p_pf2r7fd6ha",
      "p_hp2qzt4mjr",
    ],
    exactProducts: true,
    meta: {
      source: "mock",
      importedAt: "2026-03-24T13:50:10Z",
      importedBy: "retailer-themes-entity-migration",
    },
  };
